
import React, { } from 'react';
import PageBox from '../../components/PageBox';
import AboutMenu from '../../components/AboutMenu';
import AboutTitle from '../../components/AboutTitle';
import './index.less'
import news from "../../static/news/yongyou.jpg"
export default function App() {
  return (
    <>
      <PageBox useBanner={true}>
        <div className='aboutBanner'></div>
        <AboutMenu active={'3'} />
        <AboutTitle name={'新闻动态'} english={'NEWS'}  />
        <div className='newsCon'>
          <h3 className='title'>公司荣获用友第七届企业数智化创新应用开发大赛“最佳行业方案奖”！</h3>
          <div className='time'>发布时间：2025-11-19</div>
          <div className='newsCon-con'>
            <p>用友第七届企业数智化创新应用开发大赛获奖结果公示！深圳市远东数智采技术服务有限公司荣获用友第七届企业数智化创新应用开发大赛中荣获大中型企业赛道“最佳行业方案奖”</p>
            <p style={{textAlign:'center'}}><img src={news} /></p>
          </div>
        </div>
      </PageBox>
    </>
  );
}
